<script lang="ts">
import Basic from '@nuxtDatakodeUtils/components/list/Filters/Basic.vue'
import type { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import type { HelperService } from '@nuxtDatakodeUtils/utils/helper.service'

export default {
    name: 'BasicFiltersOverride',
    extends: Basic,
    computed: {
        i3pService(): I3pService {
            return this.getI3pComponent()?.$props?.i3pService as I3pService
        },
        serviceQuery() { // query var is taken by BasicFilters
            return this.i3pService._query
        },
    },
    watch: {
        serviceQuery(currentQuery) {
            if (currentQuery) {
                this.filtersSetted.forEach((filter, i) => {
                    let isFilterActive = currentQuery[`filter[${filter.name}]`] || null

                    if (isFilterActive) {
                        if (typeof isFilterActive === 'string') {
                            isFilterActive = isFilterActive.split(',')
                        }
                        if (isFilterActive?.constructor === Object) { // IF OPERATOR
                            // Handle several same filter with operators.
                            // If same filter is found b4 current index, use operator of the found.length (if already 2 passed, it will be Object.keys(operators)[2])
                            const passedSameFilters = this.filtersSetted.slice(0, i).filter(f => f.name === filter.name)

                            const operator = Object.keys(isFilterActive)[passedSameFilters.length]
                            this.updateOperator(filter, operator, i)
                            this.updateFilters(filter, isFilterActive[operator], i)
                            return
                        }
                    }
                    this.updateFilters(filter, isFilterActive, i)
                })
            }
        },
    },
    methods: {
        getI3pComponent() {
            const helper: HelperService = this.$helper
            return helper.getAncestorByComponentName(this, 'I3p')
        },
    },
}
</script>
